module.exports = {"username":"Username","password":"Password","logIn":"Log in","allRightsReserved":"{name} © All Rights Reserved {date}","noMatch":"Invalid username or password"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = 813
// module chunks = 0